import { css as r } from "styled-components";
const s = ({ theme: o }) => /* @__PURE__ */ r([
  "border-radius:0.4rem;outline:0;box-shadow:0 0 0 2px ",
  ",0 0 0 4px ",
  ";"
], o.componentColors.forms.focus.borderLight, o.componentColors.forms.focus.borderDark), t = ({ theme: o }) => /* @__PURE__ */ r([
  "&:active,&:focus{",
  "}"
], o.components.forms.borderStyle), c = {
  focusActiveState: t,
  borderStyle: s
};
export {
  s as borderStyle,
  c as default
};
